<template>
  <div>
    <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="12" class="m-3" >  
         <a class="text-primary" href="#" @click.prevent="backToCompilations()">{{ $t('CashFlow.Reports.BackToCompilations')}}</a>
      </vs-col>
   </vs-row>
    <div class="powerBiContainer">
      <div id="reportContainer" />
    </div>
  </div>
</template>

<script>
import { service, factories, models } from "powerbi-client";

export default {
  data() {
    return {
      props: {
        msg: String
      }
    };
  },
  mounted() {
    this.$auth.getPowerBiToken().then(
      token => {
        this.$powerBiApi.get("/myorg/groups/" + this.$store.state.powerbiConfigurations.cashFlowGroupId + "/reports/" + this.$store.state.powerbiConfigurations.cashflowCalculated).then(
          response => {
            const compilationFilter = {
              $schema: "http://powerbi.com/product/schema#basic",
              target: {
                table: "loms_compilation_kpis_gold",
                column: "CompilationId"
              },
              operator: "In",
              values: [this.$route.query.compilationId],
              filterType: 1 // pbi.models.FilterType.BasicFilter
            }


            const config = {
              type: "report",
              tokenType: models.TokenType.Aad,
              accessToken: token.accessToken,
              embedUrl: response.data.embedUrl,
              id: this.$store.state.powerbiConfigurations.cashflowCalculated,
              permissions: models.Permissions.All,
              settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true
              },
              filters: [compilationFilter]  
            };

            const powerbi = new service.Service(
              factories.hpmFactory,
              factories.wpmpFactory,
              factories.routerFactory
            );

            const reportContainer = document.getElementById("reportContainer");
            const report = powerbi.embed(reportContainer, config);

            // Report.off removes a given event handler if it exists.
            report.off("loaded");

            // Report.on will add an event handler which prints to Log window.
            report.on("loaded", function () {
              console.log("Loaded");
            });

            // Report.off removes a given event handler if it exists.
            report.off("rendered");

            // Report.on will add an event handler which prints to Log window.
            report.on("rendered", function () {
              console.log("Rendered");
            });

            report.on("error", function (event) {
              console.log(event.detail);
              report.off("error");
            });

            report.off("saved");
            report.on("saved", function (event) {
              if (event.detail.saveAs) {
                console.log(
                  "In order to interact with the new report, create a new token and load the new report"
                );
              }
            });
          }
        );
      }
    );
  },
  methods: {
    backToCompilations() {
      this.$router.push({name: "BSG-cashflow-compilations"})
    }
  }
};
</script>
<style lang="scss">
  #reportContainer {
    width: 100%;
    height: 600px;
  }

</style>
